// utils/navigationHookRegistry.ts
let beforeRouteChange: ((next: () => void) => void) | null = null;

export function registerBeforeRouteChange(fn: (next: () => void) => void) {
  beforeRouteChange = fn;
}

export function clearBeforeRouteChange() {
  beforeRouteChange = null;
}

export function runBeforeRouteChange(next: () => void) {
  if (beforeRouteChange) {
    beforeRouteChange(next);
  } else {
    next();
  }
}
